<template>
  <div>
    <echarts-menuTwo
      :dataMenu="dataMenu"
      @changeydata="onchangeData"
    ></echarts-menuTwo>
    <textEchartsTwo
      v-if="showChartOrList"
      :data="showData"
      class="echarts"
    ></textEchartsTwo>
    <home-tableTwo v-else></home-tableTwo>
  </div>
</template>
<script>
import echartsMenuTwo from "./echarts-menuTwo.vue";
import textEchartsTwo from "./text-echartsTwo.vue";
import homeTableTwo from "./homeTableTwo.vue";
import { storeMainInfo } from "@/api/storeApi.js";
export default {
  data() {
    return {
      date: {
        endDate: "",
        startDate: "",
      },
      showChartOrList: true,
      dataMenu: {
        orderNumData: {
          name: "下单数量（最近15日）",
          val: "orderNumData",
          index: 1,
        },
        orderMoneyData: {
          name: "下单金额（最近15日）",
          val: "orderMoneyData",
          index: 2,
        },
        // countNewUserNum: {
        //   name: "日新增会员用",
        //   val: "countNewUserNum",
        //   index: 3,
        // },
        // accountChartLoginMonthData: {
        //   name: "用户活跃度",
        //   val: "accountChartLoginMonthData",
        //   index: 4,
        // },
        // hydbb: {
        //   name: "活跃度报表",
        //   val: "hydbb",
        //   index: 5,
        // },
      },
      showData: [],
      Ydata: {
        orderNumData: [],
        orderMoneyData: [],
        countNewUserNum: [],
        accountChartLoginMonthData: [],
        hydbb: [],
      },
    };
  },
  components: {
    echartsMenuTwo,
    textEchartsTwo,
    homeTableTwo,
  },
  mounted() {
    this.getMainInfo();
  },
  methods: {
    onchangeData(val) {
      this.showData = this.Ydata[val.val];
      if (val.val === "hydbb") {
        // false为显示报表，true显示图表
        this.showChartOrList = false;
      } else {
        this.showChartOrList = true;
      }
    },
    getMainInfo() {
      storeMainInfo(this.date).then((res) => {
        // debugger
        this.showData = JSON.parse(res.data.orderNumData)
        this.Ydata.orderNumData = JSON.parse(res.data.orderNumData);
        this.Ydata.orderMoneyData = JSON.parse(res.data.orderMoneyData);
        // this.Ydata.countNewUserNum = JSON.parse(res.data.countNewUserNum);
        // this.Ydata.accountChartLoginMonthData = JSON.parse(res.data.accountChartLoginMonthData);
      });
    },
  },
};
</script>
<style>
.echarts {
  /* width: 1115px; */
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/homeEchatrsTwo.vue